import { Col, Row } from 'react-bootstrap';

export default function PrestacaoContasAnual() {
    return <Row>
        <Col xs="12">
            <p><small>Você está em <a href="/financas">Prestação de Contas</a> / Prestação de Contas da Alepe</small></p>
        </Col>
        <Col xs="12">
            <h1>Prestação de Contas da Alepe</h1>
            <p>As prestações de contas da ALEPE, a partir de 2014, podem ser consultadas no sistema e-TCE, clicando no ícone abaixo:</p>
        </Col>
        <Col xs="12" className="text-center">
            <a href="http://etce.tce.pe.gov.br/epp/ConsultaPublica/listView.seam" rel="noopener" target="_blank"><img src="/img/tce.png"/></a>
        </Col>
    </Row>

}